module.exports = __webpack_public_path__ + "img/redirect-to-full-page-bg.570cffda.png";